var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7499 5L21.7499 4.25L20.9999 4.25L2.99999 4.2501L2.24999 4.25011L2.25 5.00011L2.25007 19L2.25008 19.75H3.00007H21H21.75L21.75 19L21.7499 5ZM3.75007 18.25L3.75 5.7501L20.2499 5.75001L20.25 18.25H3.75007ZM6.41602 7.37597L5.79198 6.95994L4.95993 8.20802L5.58397 8.62404L11.584 12.624L12 12.9014L12.416 12.624L18.416 8.62404L19.0401 8.20802L18.208 6.95994L17.584 7.37597L12 11.0986L6.41602 7.37597Z",
    fill: "#020617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.b83077d675896ee70164523e98ed928f.svg";
export { ForwardRef as ReactComponent };